import React, { Suspense, memo } from "react";
import styles from "./PostLogin.module.scss";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "@/store/slices/globalSlice";
import { type RootState } from "@/store/rootReducer"; 
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import DashboardHeaderComponent from "@/components/DashboardHeader/DashboardHeaderComponent";

const HomeLayout: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const sidebarOpen = useSelector((state: RootState) => state.global.sidebarOpen);

  const toggleSidebarOpen = (flag: boolean) => () => {
    if (sidebarOpen !== flag) {
      dispatch(setSidebarOpen(flag));
    }
  };

  const isDashboardRoute = location.pathname === "/dashboard";

  return (
    <div className={styles.layout}>
      <Sidebar toggleSidebarOpen={toggleSidebarOpen} />
      <div className={styles.rightSideContainer}>
        {isDashboardRoute && <DashboardHeaderComponent />}
        <div className={styles.outletDiv}>
          <Suspense fallback={<Loader />}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default memo(HomeLayout);
